import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin: 12px 0;
  width: 100%;
  max-width: 400px;
`;

export const FieldLabel = styled.label`
  font-weight: bold;
  margin-bottom: 6px;
`;

export const UpdateNoteInput = styled.input`
  padding: 8px;
  font-size: 14px;
`;

export const UpdateNoteTextarea = styled.textarea`
  padding: 8px;
  font-size: 14px;
  min-height: 100px;
  resize: vertical;
`;

export const UpdateNoteSelect = styled.select`
  padding: 8px;
  font-size: 14px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
`;